<template>
  <div class="my-breadcrumb" ref="myBreadcrumb">
    <b-link v-for="(item, i) in items" :key="i" :to="item.url">
      {{ item.text }}
    </b-link>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getHeight() {
      return this.$refs.myBreadcrumb.clientHeight;
    }
  }
};
</script>

<style>
.my-breadcrumb {
  min-height: 35px;
  background-color: #eeeff0;
  padding: 0 15px;
}

.my-breadcrumb a {
  font-size: 11px;
  line-height: 1.27;
  color: #949494;
  display: inline-block;
  padding: 11px 8px 11px 0;
}

.my-breadcrumb a::after {
  content: ">";
  padding-left: 5px;
}

.my-breadcrumb a:hover {
  text-decoration: none;
}

.my-breadcrumb a:last-child {
  font-weight: bold;
  color: #009feb;
}

.my-breadcrumb a:last-child::after {
  content: "";
}
</style>
